export const LOCATING_FACE_CODE_KEY = `VANS_064`;

export const RAIL_MIN_STEP_TO_BUY = 3; // counted from 0, so 4th step
export const RAIL_MIN_STEP_TO_SAVE = 2; // counted from 0, so 3rd step
